var CommunitySubscriptionErrorCode;
(function(CommunitySubscriptionErrorCode) {
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Пользователь не имеет аккаунта ВКонтакте
   */ "IsServiceAccount"] = 200] = "IsServiceAccount";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Ошибка при получении данных группы
   */ "GroupNotFound"] = 201] = "GroupNotFound";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Группа закрыта
   */ "GroupClosed"] = 202] = "GroupClosed";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Пользователь уже подписан на группу
   */ "AlreadyMember"] = 203] = "AlreadyMember";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Access Token был получен без scope 'groups'
   */ "ScopeMissing"] = 204] = "ScopeMissing";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Неизвестная ошибка при выполнении запроса
   */ "UnknownError"] = 205] = "UnknownError";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Неправильные параметры в запросе
   */ "BadRequest"] = 206] = "BadRequest";
    CommunitySubscriptionErrorCode[CommunitySubscriptionErrorCode[/**
   * Достигнут лимит показа окна подписки
   */ "RemoteLimitReached"] = 207] = "RemoteLimitReached";
})(CommunitySubscriptionErrorCode || (CommunitySubscriptionErrorCode = {}));

export { CommunitySubscriptionErrorCode };
